<template>
  <div
    v-if="activeQuestion"
    class="unm__outer the-question question__stage">
    <img
      :src="activeQuestion.gesturalImage"
      alt=""
      class="question__gestural-image"
    >
    <div class="unm__background question__background"/>
    <div class="unm__container">
      <div class="question__container">
        <div class="question__question-container">
          <p
            class="paragraph paragraph-quiz question__question"
            v-text="activeQuestion.prompt"
          />
        </div>
        <div class="question__responses">
          <ul class="question-response__list">
            <li
              v-for="(choice, index) in activeQuestion.choices"
              :key="index"
              :class="activeQuestion.type"
              class="question-response__list-item"
            >
              <component
                :is="is"
                v-bind="choice"
                :checked="answer === choice"
                @change.native="answer = choice"
              />
            </li>
          </ul>
        </div>
        <div class="quiz__breaker-container">
          <hr class="quiz__breaker">
        </div>
        <div class="question__next-container">
          <div class="question__next">
            <button
              :disabled="!answer"
              class="cta-small transparent-cta"
              @click="answerQuestion(answer)"
            >Next
              <svg class="cta-small__arrow">
                <use xlink:href="/images/icons/arrow-icon.svg#arrow-icon" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';

  import { capitalize } from '@/util';
  import RadioBorder from '@/components/RadioBorder';
  import ChoiceImage from '@/components/ChoiceImage';
  import ChoiceSimple from '@/components/ChoiceSimple';
  import ChoiceIcon from '@/components/ChoiceIcon';
  import ChoiceButton from '@/components/ChoiceButton';
  import ChoiceEmoji from '@/components/ChoiceEmoji';

  // import { stage } from '@/mixins';

  export default {
    name: 'TheQuestion',
    components: {
      RadioBorder,
      ChoiceImage,
      ChoiceSimple,
      ChoiceIcon,
      ChoiceButton,
      ChoiceEmoji,
    },
    data() {
      return {
        answer: undefined,
      };
    },
    computed: {
      is() {
        return `Choice${capitalize(this.activeQuestion.type)}`;
      },
      ...mapState(['questions', 'activeQuestion', 'stage']),
      ...mapGetters(['activeQuestionIndexString']),
    },
    activated() {
      if (!this.activeQuestion.choices.includes(this.answer)) {
        this.answer = undefined;
      }

      this.setHud({
        top: 'Question',
        bottom: `0${this.activeQuestionIndexString}`,
      });
    },
    methods: {
      ...mapMutations([
        'answerQuestion',
        'setHud',
      ]),
    },
  };
</script>

<style lang="scss">

.question__gestural-image {
    display: none;

    @include breakpoint(large) {
      position: absolute;
      top: 50%;
      left: -200px;
      display: block;
      width: 300px;
      height: 300px;
      margin-top: -200px;
      object-fit: cover;
    }
}

.question__background {
  display: none;

  @include breakpoint(large) {
    display:  block;
    background-image: url("/images/backgrounds/background-glyph-02.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 0;
    opacity: 0.3;
  }
}

.question__container {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 100px;

  @include breakpoint(large) {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.question__question-container {
  @include flex-grid-row(12);
}

.question__question,
.quiz__breaker-container {
  @include flex-grid-column(12);

  @include breakpoint(medium) {
    @include flex-grid-column(8)
    @include grid-column-offset(2)
  }
}

.question__responses {
  @include flex-grid-column(12, 0);

  @include breakpoint(large) {
    @include flex-grid-column(9, 0)
    @include grid-column-offset(2)
  }
}

.question-response__list {
    @include flex-grid-row(12);
    margin-top: 30px;
    margin-bottom: 30px - $choice-bottom-margin;

    @include breakpoint(large) {
        margin-top: 55px;
        margin-bottom: 65px - $choice-bottom-margin;
    }
}

.question-response__list-item {
    display: block;
    width: 100%;
    margin-bottom: $choice-bottom-margin;
    text-align: left;

    @include breakpoint(medium) {
        display: inline-block;
        width: auto;
    }

    &.image,
    &.icon {
      @include flex-grid-column(12);

      @include breakpoint(medium) {
        @include flex-grid-column(6);
      }

      @include breakpoint(large) {
          @include flex-grid-column(4);
      }
    }

    &.simple {
      @include flex-grid-column(12);

      @include breakpoint(medium) {
        @include flex-grid-column(5);
        @include grid-column-offset(1);

        @include breakpoint(large) {
            @include flex-grid-column(4);
            @include grid-column-offset(0);
        }
      }
    }

    &.emoji {
      @include flex-grid-column(12);

      @include breakpoint(medium) {
        @include flex-grid-column(6);
      }

      @include breakpoint(large) {
          @include flex-grid-column(1.5);
      }
    }
}

.quiz__breaker {
    margin: 0;
    height: 4px;
    background-color: $green-chili;
    border: 0;
}

.question__next-container {
  @include flex-grid-row(12);
}

.question__next {
  @include flex-grid-column(12);
  display: flex;
  justify-content: center;
  margin-top: 35px;

  @include breakpoint(large) {
    margin-top: 65px;
  }
}

.quiz__breaker + .transparent-cta {
  margin-top: 35px;

  @include breakpoint(large) {
    margin-top: 65px;
  }
}

.question__container {
  .v-enter &,
  .v-leave-to & {
    @include breakpoint(large) {
      opacity: 0;
    }
  }

  .v-enter & {
    @include breakpoint(large) {
      transform: translateY(25%);
    }
  }

  .v-leave-to & {
    @include breakpoint(large) {
      transform: translateY(-25%);
    }
  }

  .v-enter-active &,
  .v-leave-active & {

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration/3;
      transition-property: opacity, transform;
      transition-timing-function: $transition-timing-function;
    }
  }

  .v-enter-active & {

    @include breakpoint(large) {
      transition-delay: $stage-transition-duration/3;
    }
  }
}

.question__background {
  .v-enter &,
  .v-leave-to & {
    @include breakpoint(large) {
      transform: translateX(100%);
    }
  }

  .v-enter-active &,
  .v-leave-active & {

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration/3;
      transition-property: opacity, transform;
      transition-timing-function: $transition-timing-function;
    }
  }

  .v-leave-active & {

    @include breakpoint(large) {
      transition-delay: $stage-transition-duration/3;
    }
  }
}

.question__gestural-image {
  .v-enter &,
  .v-leave-to & {

    @include breakpoint(large) {
      opacity: 0;
      transform: translateX(-100%);
    }
  }

  .v-enter-active &,
  .v-leave-active & {

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration/3;
      transition-property: opacity, transform;
      transition-timing-function: $transition-timing-function;
    }
  }

  .v-leave-active & {

    @include breakpoint(large) {
      transition-delay: $stage-transition-duration/3;
    }
  }
}

.the-question {

  &.v-enter {

    @media (min-width:321px) and (max-width:1024px) {
      opacity: 0;
      transform: translateX(25%);
    }
  }

  &.v-leave-to {

    @media (min-width:321px) and (max-width:1024px) {
      opacity: 0;
      transform: translateX(-25%);
    }
  }

  &.v-enter-active,
  &.v-leave-active {

    @media (min-width:321px) and (max-width:1024px) {
      transition-duration: $stage-transition-duration/2;
      transition-property: transform, opacity;
      transition-timing-function: $transition-timing-function;
    }

    @include breakpoint(large) {
      transition-duration: $stage-transition-duration;
      transition-property: opacity, transform;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheQuestion.vue